import { Dispatch, SetStateAction, useState } from "react";
import Input from "../../../components/Input/Input";
import ModalWindow from "../../../components/ModalWindow/ModalWindow";
import StandartButton from "../../../components/StandartButton/StandartButton";
import { emptyMultiLangStrings, siteLangs } from "../../../constans/siteLangs";
import { getTranslation } from "../../../utils/getTranslation";
import { areAllTextFieldsFilled } from "../../../utils/validations";
import s from "./Tables.module.css";

type MergeModalProps = {
  modalIsOpen: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
  mergeFunction: (
    title: {
      text: string;
      language: string;
    }[]
  ) => Promise<void>;
};

const MergeModal = ({
  modalIsOpen,
  setModalIsOpen,
  mergeFunction,
}: MergeModalProps) => {
  const [selecLangForText, setSelecLangForText] = useState("en");
  const [certificatesTitle, setCertificatesTitle] = useState(
    emptyMultiLangStrings
  );
  return (
    <ModalWindow isOpen={modalIsOpen} setIsOpen={setModalIsOpen}>
      <div className={s.mergeModalContent}>
        <div className={s.langsBlock}>
          {siteLangs.map((item, index) => (
            <div
              key={index}
              className={
                selecLangForText === item.value ? s.activeTab : s.notActiveTab
              }
              onClick={() => setSelecLangForText(item.value)}
            >
              {item.lable}
              {selecLangForText === item.value && (
                <span className={s.tabIndicator}></span>
              )}
            </div>
          ))}
        </div>
        <Input
          inputValue={getTranslation(certificatesTitle, selecLangForText, true)}
          onChangeInput={(value) =>
            setCertificatesTitle((prev) =>
              prev.map((item) => {
                if (item.language === selecLangForText) {
                  return {
                    ...item,
                    text: value,
                  };
                }
                return item;
              })
            )
          }
          isVisible
          required
          lable="Certificate title"
          margin="0 0 20px 0"
        />
        <StandartButton
          buttonTitle="Merge"
          action={() => mergeFunction(certificatesTitle)}
          disabled={!areAllTextFieldsFilled(certificatesTitle)}
          width="300px"
        />
      </div>
    </ModalWindow>
  );
};

export default MergeModal;
